module.exports = __webpack_public_path__ + "static/media/Nasa.ddf55214.PNG";